import { ReactElement } from "react";
import { Fab } from "@mui/material";
import styled from "styled-components/macro";

import { brightBlue, medBlue } from "../../../constants/colors";

import { useTooltipStorybookFriendly } from "./useTooltipStorybookFriendly";

interface Props {
  isAvailable: boolean;
  onClick(): void;
  children: React.ReactNode;
  tooltipTitle: string;
}

const TimeAxisControlButtonStyles = styled.span`
  &:not(:last-child) {
    margin-right: 1em;
  }
  button {
    transition: all 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);
    color: rgba(0, 0, 0, 0.26) !important;
    background-color: rgba(0, 0, 0, 0.12) !important;
    &.active {
      color: white !important;
      background-color: ${brightBlue} !important;
      &:hover {
        background-color: ${medBlue} !important;
      }
    }
    letter-spacing: 0.12em;
  }
`;

export default function TimeAxisControlButton({
  isAvailable,
  onClick,
  tooltipTitle,
  children,
}: Props) {
  const TooltipOrFragment = useTooltipStorybookFriendly();
  return (
    <TimeAxisControlButtonStyles className="doNotPrint">
      <TooltipOrFragment
        placement="top"
        title={tooltipTitle}
        disableInteractive={true}
      >
        <div>
          <Fab
            className={isAvailable ? " active" : ""}
            disabled={!isAvailable}
            onClick={onClick}
            size="small"
          >
            {children as ReactElement<any, string>}
          </Fab>
        </div>
      </TooltipOrFragment>
    </TimeAxisControlButtonStyles>
  );
}
